import React, { Component, Fragment } from 'react';
import NewInnerMainContainerMenu from './NewInnerMainContainerMenu';

class NewMegamenu extends Component {
  state = { selectData: { l2subcategories: [] } }

  componentDidMount() {
    this.setHeightContainer();
  }

  setHeightContainer = () => {
    const targetContainer = document.getElementById('inner-menu') || {};
    const heightPage = document.body.scrollHeight;
    const toPixels = `${heightPage.toString()}px`;
    targetContainer.style.height = toPixels;
  }

  setSelectData = (updateSelectedData) => {
    this.setState({ ...this.state, selectData: updateSelectedData });
  }

  setAllBlurOverMegaMenu = (updateAllBlurOverMegaMenu) => {
    this.setState({ ...this.state, allBlurOverMegaMenu: updateAllBlurOverMegaMenu });
  }

  render() {
    const { megamenu, handleClickMegamenu } = this.props;

    return (
      <Fragment>
        <div
          id="inner-menu"
          className="mainContainerMegamenu"
        >
          <NewInnerMainContainerMenu
            closeShowMenu={handleClickMegamenu}
            setSelectData={this.setSelectData}
            selectData={this.state.selectData}
            allBlurOverMegaMenu={this.state.allBlurOverMegaMenu}
            setAllBlurOverMegaMenu={this.setAllBlurOverMegaMenu}
            data={megamenu}
          />

        </div>
      </Fragment>
    );
  }
}

export default NewMegamenu;
